import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RisorseService } from '../../service/risorse.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class RisorsaGuard {
  constructor(
    private router: Router,
    private location: Location,
    private risorseService: RisorseService
  ) {}

  canActivate(): boolean {
    if (this.risorseService.risorsa.risorsa == null) {
      this.location.back();
      return false;
    }
    return true;
  }
}
